module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAFCAYAAACJmvbYAAAAcElEQVQYV2NMTU1dxsjIGMmABv7//7+cMSEhQYCNje0SAwODLJL841+/fukxggTS0tIcGRgY9jAwMDAxMDD8Y2BgcJk1a9Z+sCRUQQ8DA0MxAwND76xZs0pAYnDJ3Nxc9p8/f85hZ2dPmTx58k+QJAALUx8LyrmEmQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/image/jt.png
// module id = oyEv
// module chunks = 29